import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import ContactUsBlockData from 'Models/Content/ContactUsBlockData';
import IconBlockData from 'Models/Content/IconBlockData';
import ContactUsItem from './ContactUsItem';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import {Container} from 'reactstrap';

const ContactUsBlock = (props: ComponentProps<ContactUsBlockData>) => {
  const {data, context} = props;
  const {fadeClass, ref} = useFadeIn();

  const items = data.icons?.expandedValue?.map(({link, image, description}: IconBlockData) => ({
    href: link.value,
    title: description.value,
    image: getBackgroundImageProps(image, context),
  }));

  return (
    <div ref={ref} className='ContactUsBlock'>
      <Container className={`d-flex flex-column ${fadeClass}`}>
        <h3>{data.title.value}</h3>
        <div className='ContactUsBlock__icons'>
          {items?.map((itemProps, i) => (
            <ContactUsItem key={i} {...itemProps} />
          ))}
        </div>
        {data.link.value && data.link.value.length > 0 && (
          <a className='ContactUsBlock__link' href={data.link.value}>
            {data.linkTitle.value}
          </a>
        )}
      </Container>
    </div>
  );
};

export default ContactUsBlock;
